/**
 * The rapid-fire marker: a small lightning bolt that trails the legend on a bindings-list chip.
 * (Keycaps show rapid-fire as the .kc-rf-ring overlay now, not this glyph.)
 */
export function RapidFireGlyph({ className = "kl-rf-glyph" }: { className?: string }) {
  return (
    <svg
      className={className}
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="9"
      height="9"
      fill="currentColor"
    >
      <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
    </svg>
  );
}
